import * as React from 'react'

export function UnicornIcon(props: any) {
    return (
        <svg
            width={44}
            height={51}
            viewBox='0 0 44 51'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}>
            <path
                d='M29.89 12.562l4.933-4.934M21.232 26.282a4.609 4.609 0 01-4.609-4.608'
                stroke='#2E2D2C'
                strokeWidth={2.32}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M34.823 7.628A19.171 19.171 0 0021.23 2C10.61 2 2 10.61 2 21.23v14.928l6.307 6.307v6.679M8.312 21.23c0-7.135 5.784-12.918 12.918-12.918M23.758 26.282V34.1M16.284 32.313c9.124 0 16.522 7.398 16.522 16.523'
                stroke='#2E2D2C'
                strokeWidth={2.32}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M33.81 16.486l7.91-11.764c.975-1.448-.78-3.162-2.456-1.494L29.931 12.6'
                stroke='#fff'
                strokeWidth={2.32}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M33.81 16.486l7.91-11.764c.975-1.448-.78-3.162-2.456-1.494L29.931 12.6'
                stroke='#2E2D2C'
                strokeWidth={2.32}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M27.51 10.188l12.98 12.979'
                stroke='#fff'
                strokeWidth={2.32}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M27.51 10.188l12.978 12.977v4.186l-2.758 2.757c-.63.63-1.65.63-2.278 0l-2.82-2.82a3.441 3.441 0 00-2.433-1.007h-8.967M23.032 15.51h2.54'
                stroke='#2E2D2C'
                strokeWidth={2.32}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export function KYCIcon(props: any) {
    return (
        <svg
            width={44}
            height={51}
            viewBox='0 0 44 51'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}>
            <path
                d='M42 11.266v3.574c0 14.08-7.597 27.23-19.828 34.314'
                stroke='#2E2D2C'
                strokeOpacity={0.5}
                strokeWidth={2.32}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M20.152 2C16.639 6.62 9.828 9.751 2 9.751v5.088c0 13.43 7.312 25.128 18.152 31.409 10.841-6.281 18.153-17.98 18.153-31.41V9.752C30.478 9.751 23.667 6.62 20.153 2z'
                stroke='#2E2D2C'
                strokeOpacity={0.5}
                strokeWidth={2.32}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M32.91 14.702L19.313 34.126l-8.796-11.189'
                stroke='#2E2D2C'
                strokeOpacity={0.5}
                strokeWidth={2.32}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export function SecurityIcon(props: any) {
    return (
        <svg
            width={44}
            height={44}
            viewBox='0 0 44 44'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}>
            <path
                d='M37.663 42H6.337A4.337 4.337 0 012 37.663V6.337A4.337 4.337 0 016.337 2h31.326A4.337 4.337 0 0142 6.337v31.326A4.337 4.337 0 0137.663 42z'
                fill='#fff'
            />
            <path
                d='M35.578 37.061H8.422a1.483 1.483 0 01-1.483-1.483V8.422c0-.819.664-1.483 1.483-1.483h27.156c.819 0 1.483.664 1.483 1.483v27.156c0 .819-.664 1.483-1.483 1.483z'
                fill='#fff'
            />
            <path
                d='M22 31.393A9.393 9.393 0 0031.393 22 9.393 9.393 0 0022 12.607 9.393 9.393 0 0012.607 22 9.393 9.393 0 0022 31.393z'
                fill='#fff'
            />
            <path
                d='M22 28.101A6.101 6.101 0 1022 15.9 6.101 6.101 0 0022 28.1zM38.824 11.877h-3.527v4.94h3.527v-4.94zM38.824 27.184h-3.527v4.939h3.527v-4.94z'
                fill='#fff'
            />
            <path
                d='M19.512 24.488l4.976-4.976m0 4.976l-4.976-4.976M37.663 42H6.337A4.337 4.337 0 012 37.663V6.337A4.337 4.337 0 016.337 2h31.326A4.337 4.337 0 0142 6.337v31.326A4.337 4.337 0 0137.663 42zm-2.085-4.939H8.422a1.483 1.483 0 01-1.483-1.483V8.422c0-.819.664-1.483 1.483-1.483h27.156c.819 0 1.483.664 1.483 1.483v27.156c0 .819-.664 1.483-1.483 1.483zM31.393 22A9.393 9.393 0 0122 31.393 9.393 9.393 0 0112.607 22 9.393 9.393 0 0122 12.607 9.393 9.393 0 0131.393 22zm-3.292 0A6.101 6.101 0 1115.9 22 6.101 6.101 0 0128.1 22zm7.196-10.123h3.527v4.94h-3.527v-4.94zm0 15.307h3.527v4.939h-3.527v-4.94z'
                stroke='#2E2D2C'
                strokeOpacity={0.5}
                strokeWidth={2.32}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
export function ConnectedAccountsIcon(props: any) {
    return (
        <svg
            width={40}
            height={44}
            viewBox='0 0 40 44'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
            {...props}>
            <path
                fill='url(#prefix__pattern0)'
                fillOpacity={0.5}
                d='M0 0h40v44H0z'
            />
            <defs>
                <pattern
                    id='prefix__pattern0'
                    patternContentUnits='objectBoundingBox'
                    width={1}
                    height={1}>
                    <use
                        xlinkHref='#prefix__image0'
                        transform='scale(.0125 .01136)'
                    />
                </pattern>
                <image
                    id='prefix__image0'
                    width={80}
                    height={88}
                    xlinkHref='data:image/png;base64,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'
                />
            </defs>
        </svg>
    )
}

export function NotificationsIcon(props: any) {
    return (
        <svg
            width={44}
            height={51}
            viewBox='0 0 44 51'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}>
            <path
                d='M26.98 2v47.35M2 49.35h32.491M6.481 33.733L7.559 48.31c.044.576.531 1.042 1.09 1.042h5.406c.558 0 1.046-.468 1.088-1.042l2.138-28.692h9.646M6.48 33.732a4.44 4.44 0 01-.185-.022c-1.414-.21-3.378-1.343-3.492-2.64l-.801-10.758a1.98 1.98 0 01-.001-.187c0-2.144 1.687-3.926 3.764-3.977m.715 17.584l-.899-12.156m.184-5.428h24.631a3.47 3.47 0 01-3.47 3.47m-21.161-3.47H29.53c.488 0 .87.465.74.934a3.472 3.472 0 01-3.343 2.536m-15.578 13.09v16.184m.003-35.685a3.564 3.564 0 01-3.56-3.56 3.563 3.563 0 013.56-3.559 3.56 3.56 0 010 7.119zM26.98 4.064h7.509v7.02h-7.51v-7.02zM42 13.754l-3.083-3.51L42 6.733h-7.509v7.02h7.51z'
                stroke='#2E2D2C'
                strokeOpacity={0.5}
                strokeWidth={2.32}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
